export const blockIconsTransportationMotorcycleNew = (
	<span className='material-symbols-outlined'>motorcycle</span>
);
